import React from "react";
import { Card, Statistic } from "antd";
import { UserSwitchOutlined } from "@ant-design/icons";

const ProfitPercentageCard = ({ orderMetrics }) => {
  // Default values if orderMetrics is not provided
  const ordersPerBuyer = orderMetrics?.ordersPerBuyer || 0;

  return (
    <Card className="dashboard-card">
      <div className="justify-content-between align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="card-title">ORDERS PER BUYER</h5>
          <div className="icon-box purple">
            <UserSwitchOutlined />
          </div>
        </div>
        
        <Statistic 
          value={ordersPerBuyer} 
          precision={2}
          valueStyle={{ color: "#6f42c1", fontWeight: "bold", fontSize: "28px" }}
        />
      </div>
    </Card>
  );
};

export default ProfitPercentageCard;
